import { Component } from '@angular/core';

@Component({
  selector: 'rt-noop',
  template: '',
  standalone: true,
})
export class NoopComponent {}
